import './Footer.css';
import { Link } from "react-router-dom";


export default function Footer() {
    return (
        < div className="footer" >
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-contact">
                            <h2>Contact Us</h2>
                            <a href="https://maps.app.goo.gl/HQg6gMPpAJ445cda6" target="_blank" rel="noopener noreferrer"><p><i className="fa fa-map-marker-alt"></i>Kalkalji, New Delhi, India</p></a>
                            <a href="tel:+91-7385223242"><p><i className="fa fa-phone"></i>+91-9266101536</p></a>
                            <a href="navveerfoundation@gmail.com"><p><i className="fa fa-envelope"></i>navveerfoundation@gmail.com</p></a>
                            <div className="footer-social">
                                <a className="btn btn-custom" href="https://twitter.com/vit_socials"><i className="fab fa-x-twitter"></i></a>
                                <a className="btn btn-custom" href="https://www.facebook.com/vitsocials"><i className="fab fa-facebook-f"></i></a>
                                <a className="btn btn-custom" href="https://www.instagram.com/vitsocials/"><i className="fab fa-instagram"></i></a>
                                <a className="btn btn-custom" href="https://www.youtube.com/channel/UCJnaNm8Ns08rUIhsdFM2fhA"><i className="fab fa-youtube"></i></a>
                                <a className="btn btn-custom" href="https://www.linkedin.com/company/vit-social-welfare-development/"><i className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                    </div>
                  <div className="col-lg-3 col-md-6">
  <div className="footer-link">
    <h2>Popular Links</h2>
    <Link to="/">About Us</Link>
    <Link to="/contact">Contact Us</Link>
    <Link to="/event">Popular Causes</Link>
    <Link to="/event">Upcoming Events</Link>
    <Link to="/blog">Latest Blog</Link>
  </div>
</div>

<div className="col-lg-3 col-md-6">
  <div className="footer-link">
    <h2>Useful Links</h2>
    <Link to="#">Terms of use</Link>
    <Link to="#">Privacy policy</Link>
    <Link to="#">Cookies</Link>
    <Link to="#">Help</Link>
    <Link to="#">FQAs</Link>
  </div>

                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-newsletter">
                            <h2>Newsletter</h2>
                            <form name='NewsLetter'>
                                <input name='subscribe' className="form-control" placeholder="Email goes here" autoComplete='email' required/>
                                <button className="btn btn-custom">Submit</button>
                                <h6>Don't worry, we don't spam!</h6>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container copyright">
                <div className="row">
                    <div className="col-md-6">
                        <p>&copy; <Link to="/">Navveer Foundation</Link> | 2025, All Right Reserved.</p>
                    </div>
                    <div className="col-md-6">
                        {/* <p>Designed By <a href="https://www.linkedin.com/in/bhavesh-patil-92b7aa22a">TY_CS_C_52, VIT, Pune</a></p> */}
                    </div>
                </div>
            </div>
        </ div>
    );
}